import { create } from "zustand";

export type Route =
  | { name: "home" }
  | { name: "media" }
  | { name: "series"; seriesId: string }
  | { name: "recent" }
  | { name: "favorites" }
  | { name: "messages" }
  | { name: "radio" }
  | { name: "contacts" }
  | { name: "today" }
  | { name: "peace" }
  | { name: "help" };

type NavigationState = {
  route: Route;
  stack: Route[];
  mainMenuFocusRequest: number;
  go: (route: Route) => void;
  back: () => void;
  home: () => void;
};

export const useNavigationStore = create<NavigationState>((set, get) => ({
  route: { name: "home" },
  stack: [],
  mainMenuFocusRequest: 0,
  go(route) {
    const { route: current, stack } = get();
    set({ route, stack: [...stack, current] });
  },
  back() {
    const { stack } = get();
    const previous = stack.at(-1);
    set({ route: previous ?? { name: "home" }, stack: stack.slice(0, -1) });
  },
  home() {
    const { mainMenuFocusRequest } = get();
    set({
      route: { name: "home" },
      stack: [],
      mainMenuFocusRequest: mainMenuFocusRequest + 1,
    });
  },
}));
